import type { Project } from "@/api/spaces";
import { agentNameKey } from "@/components/cursors/agent-avatar-dock-utils";
import { projectColorForDisplay } from "@/lib/home-project-colors";

/**
 * Denker's avatar takes the colour of the project it works in. Every other
 * agent, and Denker without a known project colour, keeps its seeded colour.
 */
export function denkerAvatarColor(
  agentName: string | null | undefined,
  project: Pick<Project, "color" | "is_home"> | null | undefined,
): string | undefined {
  if (!project || agentNameKey(agentName ?? undefined) !== "denker") {
    return undefined;
  }
  return (
    projectColorForDisplay({ color: project.color, isHome: project.is_home }) ||
    undefined
  );
}
